<template>
  <div class="OrderDetail" v-if="detail">
    <div class="detail_item">
      <div class="detail_subitem">
        <p class="item_title">Order ID</p>
        <p class="item_text">{{detail.order_id}}</p>
      </div>
      <div class="detail_subitem">
        <p class="item_title">Order Time</p>
        <p class="item_text">{{detail.order_time}}</p>
      </div>
    </div>

    <div class="detail_item">
      <div class="detail_subitem">
        <p class="item_title">Product Name</p>
        <p class="item_text">{{detail.product_name_en}} // {{detail.product_name_cn}}</p>
      </div>
      <div class="detail_subitem">
        <p class="item_title">Quantity</p>
        <p class="item_text">{{detail.count}}</p>
      </div>
    </div>
    <div class="detail_item">
      <p class="item_title">Product Options</p>
      <div class="detail_subitem">
        <p class="item_text" v-for="option in detail.options" :key="option">{{option}}</p>
      </div>
    </div>

    <div class="detail_item">
      <div class="detail_subitem">
        <p class="item_title">Total Amount</p>
        <p class="item_text">{{detail.total_amount}}</p>
      </div>
      <div class="detail_subitem">
        <p class="item_title">Balance Used</p>
        <p class="item_text">{{detail.balance_amount}}</p>
      </div>
      <div class="detail_subitem">
        <p class="item_title">Actual Payment</p>
        <p class="item_text">{{detail.pay_amount}}</p>
      </div>
    </div>

    <div class="detail_item">
      <div class="detail_subitem">
        <p class="item_title">Recipient</p>
        <p class="item_text">{{detail.user_name}}</p>
      </div>
      <div class="detail_subitem">
        <p class="item_title">Phone Number</p>
        <p class="item_text">{{detail.tel_number}}</p>
      </div>
    </div>

    <div class="detail_item">
      <p class="item_title">Shipping Address</p>
      <p class="item_text">{{detail.province_name}} {{detail.county_name}} {{detail.city_name}} {{detail.detail_info}}
        {{detail.postal_code}}</p>
    </div>

    <div class="detail_item">
      <p class="item_title">Order State</p>
      <p class="item_text">{{detail.order_state_text}}</p>
    </div>


  </div>
</template>

<script>
  import {getOrderDetail} from "@/utils/api";

  export default {
    props: ['orderid'],
    data: () => {
      return {
        detail: false,
        track_table: []
      }
    },
    methods: {},
    beforeMount() {
      getOrderDetail(this.orderid).then(res => {
        let detail = res.detail;
        let options = [];
        detail.option_items.forEach((v, i) => {
          let name = v.name.split('//')[0].trim();
          let item = detail.option_record.options[i].split('//')[0].trim();
          options.push(`${name}: ${item}`)
        });
        detail.options = options;
        this.detail = detail;


      })
    }
  };
</script>

<style lang="scss" scoped>
  @import "_OrderDetail.scss";
</style>